// eslint-disable-next-line import/prefer-default-export
export const SHOP_THIS_STORE_ACTIONS = {
  FETCH_HLP_CATEGORY: 'FETCH_HLP_CATEGORY',
  SET_SHOP_THIS_STORE_PLP_PRODUCTS: 'SET_SHOP_THIS_STORE_PLP_PRODUCTS',
  SET_HPLP_PRODUCTS: 'SET_HPLP_PRODUCTS',
  FETCH_MORE_HORIZONTAL_CATEGORY_PRODUCTS_STS: 'FETCH_MORE_HORIZONTAL_CATEGORY_PRODUCTS_STS',

  FETCH_L1_CATEGORIES: 'FETCH_L1_CATEGORIES',
  SET_L1_CATEGORIES_LOADING: 'FETCH_L1_CATEGORIES_LOADING',
  SET_L1_CATEGORIES: 'SET_L1_CATEGORIES',

  FETCH_L2_CATEGORIES: 'FETCH_L2_CATEGORIES',
  SET_L2_CATEGORIES_LOADING: 'FETCH_L2_CATEGORIES_LOADING',
  SET_L2_CATEGORIES: 'SET_L2_CATEGORIES',
  FETCH_FILTERED_L2_AND_L1_CATEGORIES: 'FETCH_FILTERED_L2_AND_L1_CATEGORIES',
  SET_L1_CATEGORIES_FETCHED: 'SET_L1_CATEGORIES_FETCHED',

  FETCH_L1_CATEGORY_SELECTION: 'FETCH_L1_CATEGORY_SELECTION',
  SET_L1_CATEGORY_SELECTION: 'SET_L1_CATEGORY_SELECTION',
  SET_L1_CATEGORY_SELECTION_LOADED: 'SET_L1_CATEGORY_SELECTION_LOADED',

  FETCH_L2_CATEGORY_SELECTION: 'FETCH_L2_CATEGORY_SELECTION',
  SET_L2_CATEGORY_GROUPING_SELECTION: 'SET_L2_CATEGORY_GROUPING_SELECTION',
  SET_L2_CATEGORY_GROUPING_SELECTION_LOADED: 'SET_L2_CATEGORY_GROUPING_SELECTION_LOADED',

  SET_SELECTED_L1_CATEGORY_CONTENT: 'SET_SELECTED_L1_CATEGORY_CONTENT',
  SET_SELECTED_L2_CATEGORY_GROUP_ID: 'SET_SELECTED_L2_CATEGORY_GROUP_ID',

  LOADED_IN_SHOP_THIS_STORE: 'LOADED_IN_SHOP_THIS_STORE',

  SHOP_THIS_STORE_HPLP_LOADED: 'SHOP_THIS_STORE_HPLP_LOADED',

  SHOW_SHOP_THIS_STORE_NOTIFICATION: 'SHOW_SHOP_THIS_STORE_NOTIFICATION',
  SET_FILTERED_L2_AND_L1_CATEGORIES: 'SET_FILTERED_L2_AND_L1_CATEGORIES',
  SET_IS_DEFAULT_CATEGORIES_LOADED: 'SET_IS_DEFAULT_CATEGORIES_LOADED',
  SET_SELECTED_STORE_L1_CATEGORIES: 'SET_SELECTED_STORE_L1_CATEGORIES',
  SET_SELECTED_STORE_L2_CATEGORIES: 'SET_SELECTED_STORE_L2_CATEGORIES',
  CHANGE_L2_CATEGORIES: 'CHANGE_L2_CATEGORIES',
};
